import { useMutation } from "@tanstack/react-query";

import subscriptionRequestApi from "./apis/subscription_request";

const useCreateSubscriptionRequest = ({ onSuccess } = {}) =>
  useMutation({
    mutationFn: subscriptionRequestApi.create,
    onSuccess,
  });

export { useCreateSubscriptionRequest };
